/* eslint-disable camelcase */
import React from 'react';
import PropTypes from 'prop-types';
import { graphql } from 'react-relay';
import _ from 'lodash';
import { withRouter } from 'react-router-dom';

import BannerWithLabel from '~/modules/ecommerceCoreUI/components/basic/BannerWithLabel';
import ListViewLayout from '~/modules/ecommerceCoreUI/components/listViewLayout/ListViewLayout';

import withRefetchQuery from '~/modules/core/utils/relayHelpers/withRefetchQuery';
import {
  ITEMS_LIST_VIEW_PAGINATION_KEY,
  buildPaginationQueryInput,
} from '~/modules/coreUI/components/pagination';
import { ITEMS_LIST_SORTING_DROPDOWN_KEY } from '~/modules/ecommerceProducts/components/SortingDropdown';
import { ITEMS_LIST_VIEW_FILTER_KEY } from '~/modules/ecommerceCoreUI/components/listViewLayout/ItemsListFilter';
import getPaginationLimit from '~/modules/ecommerceCore/utils/getPaginationLimit';

import {
  generateURLQueryStringFromGraphQLQueryInput,
  appendQueryStringInputToGraphQLQueryInput,
} from '~/modules/core/utils/relayHelpers/refetchUtils';
import { applyPatchChain } from '~/modules/core/utils/jsHelpers/recursiveObjectPatch';

import PinnedShops from './PinnedShops';

// function uniq(arr) {
//   return [...new Set(arr)];
// }

// function getSubTracks(shops) {
//   return uniq(
//     shops
//       .flatMap(s => s.track_sub_departments)
//       .map(s => s.name),
//   );
// }

// function getShopBySubTrack(subTrack, shops) {
//   return shops.filter(
//     s => s.track_sub_departments.some(i => i.name === subTrack),
//   );
// }

// {queryResult && console.log(
//   getSubTracks(queryResult.vendors_search.result)
//     .map(subTrackName => ({
//       name: subTrackName,
//       shops: getShopBySubTrack(subTrackName, queryResult.vendors_search.result),
//     })),
// )}

function categorizeShops(shops) {
  const cats = [];
  shops.forEach((shop) => {
    shop.track_sub_departments.forEach((s) => {
      const cat = cats.find(c => c.name === s.name);
      if (cat) {
        cat.shops.push(shop);
      } else {
        cats.push({ name: s.name, shops: [shop] });
      }
    });
  });
  return cats;
}

const TrackContent = ({
  content,
  queryResult,
  isLoading,
  match: {
    params,
  },
}) => (
  <React.Fragment>
    {params.track === 'eduPark' || params.track === 'healthPark' ? (
      <ListViewLayout
        showFilterDropdown
        isLoading={isLoading}
        categorizeItemsList={queryResult && categorizeShops(queryResult?.vendors_search.result)}
        pinnedProducts={
          content.pinned_vendors ? <PinnedShops shopsList={content.pinned_vendors} /> : null
        }
        banner={content.logo ? <BannerWithLabel logo={content.logo} /> : null}
      />
    ) : (
      <ListViewLayout
        showFilterDropdown
        isLoading={isLoading}
        itemsList={queryResult ? queryResult?.vendors_search.result : []}
        pinnedProducts={
          content.pinned_vendors ? <PinnedShops shopsList={content.pinned_vendors} /> : null
        }
        banner={content.logo ? <BannerWithLabel logo={content.logo} /> : null}
      />
    )}
  </React.Fragment>
);
TrackContent.propTypes = {
  content: PropTypes.shape({
    logo: PropTypes.string,
  }).isRequired,
  queryResult: PropTypes.shape({}),
  isLoading: PropTypes.bool.isRequired,
  match: PropTypes.shape({}).isRequired,
};
TrackContent.defaultProps = {
  queryResult: [],
};
const fragment = {
  // TODO-Shope : Needs Fragment for Vendors & Related filters
  queryResult: graphql`
    fragment TrackContent_queryResult on Query
      @argumentDefinitions(input: { type: "VendorFilterInput" }) {
      vendors_search(input: $input) {
        page_info {
          ...PaginationData_pageInfo
        }
        result {
          ...Shop_shopInfo @relay(mask: false)
        }
        related_sorts {
          name
          display_name
          selected
        }
        related_filters {
          display_name
          name
          options {
            selected
            count
            name
            value
            options {
              display_name
              name
              options {
                selected
                count
                name
                value
              }
            }
          }
        }
        errors {
          field
          messages
          code
        }
      }
    }
  `,
};

const query = graphql`
  query TrackContentQuery($input: VendorFilterInput) {
    ...TrackContent_queryResult @arguments(input: $input)
  }
`;

export default withRouter(
  withRefetchQuery(
    TrackContent,
    query,
    fragment,
    TrackContent,
    props => appendQueryStringInputToGraphQLQueryInput(
      'shops_list_query_input',
      props.location.search,
      applyPatchChain([buildPaginationQueryInput(0, getPaginationLimit())], {
        input: {
          track_department_ids: [props.content.ref_id],
          vendor_track_id: props.match.params.track === 'eduPark'
            ? _.snakeCase('educationPark')
            : _.snakeCase(props.match.params.track),
          page: {
            offset: 0,
            limit: getPaginationLimit(),
          },
        },
      }),
    ),
    {
      [ITEMS_LIST_SORTING_DROPDOWN_KEY]: {
        reset: [ITEMS_LIST_VIEW_PAGINATION_KEY],
      },
      [ITEMS_LIST_VIEW_FILTER_KEY]: {
        reset: [ITEMS_LIST_VIEW_PAGINATION_KEY],
      },
    },
    {
      pageInfo: queryResult => _.cloneDeep(queryResult.vendors_search.page_info),
      filters: queryResult => _.cloneDeep(queryResult.vendors_search.related_filters),
      sortingInfo: queryResult => _.cloneDeep(queryResult.vendors_search.related_sorts),
    },
    false,
    (variables, props) => {
      // update url with filters, sort and pagination
      props.history.push({
        search: generateURLQueryStringFromGraphQLQueryInput(
          'shops_list_query_input',
          [],
          variables,
        ),
      });
    },
  ),
);
